export default __webpack_public_path__ + "static/media/execute-icon.60a23321.svg";